const roleName = (user = {}) => user.role || user.groupName || user.Group?.name || '';

export const toAuthState = (response, portal = 'user') => {
  const user = response?.data?.user;
  if (!user || response?.error) return null;

  const role = roleName(user);
  const groupWithRoles = { name: role };
  const nestedUser = { ...user, Group: { name: role } };
  const base = {
    isAuthenticated: true,
    account: { userCode: user.userCode || user.adminCode, groupWithRoles },
    userData: {
      ...user,
      userCode: user.userCode || user.adminCode,
      groupWithRoles,
      userData: nestedUser,
    },
    isLoading: false,
  };

  if (portal === 'admin') {
    return { ...base, adminData: user };
  }
  return base;
};
